import { render, staticRenderFns } from "./QuickNavigation.vue?vue&type=template&id=07613a29&scoped=true&"
import script from "./QuickNavigation.vue?vue&type=script&lang=js&"
export * from "./QuickNavigation.vue?vue&type=script&lang=js&"
import style0 from "./QuickNavigation.vue?vue&type=style&index=0&id=07613a29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07613a29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VCard } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBottomSheet,VCard,VTextField})
